export const isNaKartuPage = (pathname: string) => pathname === '/zaimy/na-kartu/';
